import { render, staticRenderFns } from "./service-management.vue?vue&type=template&id=1f38e8ba&scoped=true"
import script from "./service-management.vue?vue&type=script&lang=js"
export * from "./service-management.vue?vue&type=script&lang=js"
import style0 from "./service-management.vue?vue&type=style&index=0&id=1f38e8ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38e8ba",
  null
  
)

export default component.exports